import React from 'react'

import { FilterSections } from '../components/FilterSections'
import { FilterSectionsHeader } from '../components/FilterSectionsHeader'
import { TabList } from '../components/TabList'
import { TextHero } from '../components/TextHero'
import { WizardCTA } from '../components/WizardCTA'
import { TabRouter } from '../TabRouter'

const ListScreen = () => {
  return (
    <div className='list-screen'>
      <div className='list-screen__hero-area'>
        <TextHero />
        <WizardCTA />
      </div>

      <div className='list-screen__grid list-screen__bar-grid'>
        <FilterSectionsHeader />

        <div>
          <TabList />
        </div>
      </div>

      <div className='list-screen__line-divider'></div>

      <div className='list-screen__grid list-screen__content-grid'>
        <div>
          <FilterSections />
        </div>

        <div>
          <TabRouter />
        </div>
      </div>
    </div>
  )
}

export { ListScreen }
